"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var styled_1 = __importDefault(require("@emotion/styled"));

var RyersonLogoSvg = function RyersonLogoSvg(_ref) {
  var className = _ref.className,
      width = _ref.width,
      height = _ref.height,
      color = _ref.color,
      cursor = _ref.cursor,
      _ref$onClick = _ref.onClick,
      _onClick = _ref$onClick === void 0 ? function () {
    return false;
  } : _ref$onClick;

  var SvgWrapper = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\tsvg {\n\t\t\twidth: ", ";\n\t\t\theight: ", ";\n\t\t\tfill: ", ";\n\t\t\tcursor: ", ";\n\t\t}\n\t"])), width, height, color, cursor);
  return (0, jsx_runtime_1.jsx)(SvgWrapper, {
    className: className,
    onClick: function onClick(e) {
      return _onClick(e);
    },
    children: (0, jsx_runtime_1.jsx)("svg", {
      "aria-hidden": "true",
      focusable: "false",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 2350.7732 297.44",
      children: (0, jsx_runtime_1.jsx)("g", {
        transform: "matrix(1.3333333,0,0,-1.3333333,0,297.44)",
        id: "g10",
        children: (0, jsx_runtime_1.jsxs)("g", {
          transform: "scale(0.1)",
          id: "g12",
          children: [(0, jsx_runtime_1.jsx)("path", {
            id: "path14",
            d: "m 1478.77,911.75 c 182.19,31.398 513.55,198.53 513.55,620.26 0,561.04 -431.91,633.01 -808.28,633.01 H 0 V 67.4414 H 436.699 V 879.309 H 976.945 L 1575.56,67.4414 h 538.79 z M 436.699,1796.18 h 639.521 c 318,0 479.48,-42.18 479.48,-272.56 0,-232.85 -161.48,-275.47 -479.48,-275.47 H 436.699 v 548.03"
          }), (0, jsx_runtime_1.jsx)("path", {
            id: "path16",
            d: "M 4094.08,2165.02 3463.03,1302.4 2829.25,2165.02 H 2293.2 L 3244.81,904.73 V 67.4414 h 436.62 V 904.73 l 951.52,1260.29 h -538.87"
          }), (0, jsx_runtime_1.jsx)("path", {
            id: "path18",
            d: "M 5516.42,447.66 V 982.949 H 6737.51 V 1363.17 H 5516.42 v 421.63 h 1407.39 v 380.22 H 5079.72 V 67.4414 H 6924.67 V 447.66 H 5516.42"
          }), (0, jsx_runtime_1.jsx)("g", {
            transform: "scale(1.08164)",
            id: "g20",
            children: (0, jsx_runtime_1.jsx)("path", {
              id: "path22",
              d: "M 15903,2001.6 V 695.848 L 14807.7,2001.6 h -422.6 V 62.3508 h 394.3 V 1418.35 L 15927.1,62.3508 H 16300 V 2001.6 h -397"
            })
          }), (0, jsx_runtime_1.jsx)("path", {
            id: "path24",
            d: "m 9082.42,911.75 c 182.28,31.398 513.55,198.53 513.55,620.26 0,561.04 -431.91,633.01 -808.28,633.01 H 7603.65 V 67.4414 h 436.7 V 879.309 H 8580.6 L 9179.21,67.4414 H 9718 Z m -1042.07,884.43 h 639.52 c 318,0 479.48,-42.18 479.48,-272.56 0,-232.85 -161.48,-275.47 -479.48,-275.47 h -639.52 v 548.03"
          }), (0, jsx_runtime_1.jsx)("path", {
            id: "path26",
            d: "m 11504.4,1317.35 h -521.9 c -224.2,0 -323.9,46.38 -323.9,227.12 0,204.18 116.1,244.58 443.3,244.58 h 890.2 l 137,376.88 h -1101.7 c -353.9,0 -797.6,-93.28 -797.6,-621.46 0,-442.95 308.3,-593.482 796.4,-593.482 h 498.9 c 236.4,0 323.9,-76.847 323.9,-244.226 0,-211.121 -129.5,-249.293 -439.1,-249.293 H 10364.2 L 10222.8,68.1797 h 1280.4 c 226.7,0 774.6,35.9413 774.6,638.5823 0,361.808 -183.9,610.588 -773.4,610.588"
          }), (0, jsx_runtime_1.jsx)("path", {
            id: "path28",
            d: "m 13992.6,2230.82 h -259.2 c -756.6,0 -1031.9,-541.53 -1031.9,-1083.06 v -64.61 C 12701.5,541.531 12976.8,0 13733.4,0 h 259.2 c 756.6,0 1031.9,541.531 1031.9,1083.15 v 64.61 c 0,536.57 -275.3,1083.06 -1031.9,1083.06 m 614.1,-1093.93 v -42.96 c 0,-315.52 -114.1,-691.629 -657.6,-691.629 h -172.2 c -418,0 -657.7,252.109 -657.7,691.629 v 42.96 c 0,471.87 209,691.63 657.7,691.63 h 172.2 c 449.1,0 657.6,-219.76 657.6,-691.63"
          })]
        })
      })
    })
  });
};

exports.default = RyersonLogoSvg;